import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Row,
  Col,
  Table,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

import AdminPage from '../../components/admin/AdminPage';
import useNearByPlace from './hooks/useNearByPlace';
import LoadingCard from '../../components/LoadingCard';
import SweetAlert from 'react-bootstrap-sweetalert';

const ProjectConfigNearByPlace = () => {
  const pageName = 'Sitios de interés';
  const pageParentName = 'Inversiones';
  const {
    results,
    handleEdit,
    handleSubmit,
    onSubmit,
    control,
    errors,
    editingId,
    reset,
    setEditingId,
    isLoading,
    // Sweet alert
    sweetAlert,
    alertProps,
    // search bar
    searchQuery,
    setSearchQuery,
    filteredResults,
  } = useNearByPlace();

  if (isLoading)
    return <LoadingCard name={pageName} parent_name={pageParentName} />;

  return (
    <AdminPage name={pageName} parentName={pageParentName}>
      {sweetAlert && (
        <SweetAlert {...alertProps}>{alertProps.text || ''}</SweetAlert>
      )}
      <Row>
        {/* Table Column */}
        <Col md="6">
          <h5>Resultados</h5>
          <Input
            type="text"
            placeholder="Buscar por nombre"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="mb-3"
          />
          <div
            style={{
              height: '500px',
              overflow: 'scroll',
            }}
          >
            <Table className="align-items-center" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Nombre</th>
                  <th scope="col">Acciones</th>
                </tr>
              </thead>
              <tbody>
                {filteredResults.length > 0 ? (
                  filteredResults.map((result) => (
                    <tr key={result.id}>
                      <td>{result.name}</td>
                      <td>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn-icon-only text-light"
                            href="#"
                            role="button"
                            size="sm"
                            color=""
                            onClick={(e) => e.preventDefault()}
                          >
                            <i className="fas fa-ellipsis-v" />
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-arrow" right>
                            <DropdownItem onClick={() => handleEdit(result.id)}>
                              Editar
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={2} className="text-center">
                      No hay resultados que coincidan con la búsqueda
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Col>

        {/* Form Column */}
        <Col md="6">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup>
              <Label for="name">Nombre</Label>
              <Controller
                name="name"
                control={control}
                rules={{
                  required: 'El nombre es obligatorio', // Validation rule
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    id="name"
                    type="text"
                    placeholder="Ingrese el nombre"
                    className={errors.name ? 'is-invalid' : ''}
                  />
                )}
              />
              {errors.name && (
                <div className="text-danger">{errors.name.message}</div>
              )}
            </FormGroup>
            <Button color="primary" type="submit">
              {editingId !== null ? 'Actualizar' : 'Guardar'}
            </Button>
            {editingId !== null && (
              <Button
                color="secondary"
                type="button"
                onClick={() => {
                  reset(); // Reset the form
                  setEditingId(null); // Clear editing state
                }}
                className="ms-2"
              >
                Cancelar
              </Button>
            )}
          </Form>
        </Col>
      </Row>
    </AdminPage>
  );
};

export default ProjectConfigNearByPlace;
